import React from 'react'
import Pagination from 'react-js-pagination'
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi'
const TablePagination = ({ currentPage, total, perPage, onChange, from, to, pageRangeDisplayed = 10 }) => {
    return (
        <div className="mt-4 row">
            <div className="col-sm-12 col-md-5">
                <div className="dataTables_info" id="example_info" role="status" aria-live="polite">
                    Showing {from} to {to} of {total} entries
                </div>
            </div>
            <div className="col-sm-12 col-md-7">
                <div className="dataTables_paginate paging_simple_numbers" id="example_paginate">
                    <Pagination
                        activePage={currentPage}
                        totalItemsCount={Number(total)}
                        itemsCountPerPage={Number(perPage)}
                        onChange={onChange}
                        innerClass="pagination float-right"
                        itemClass="page-item "
                        linkClass="page-link"
                        activeClass="active"
                        activeLinkClass="active"
                        prevPageText={<FiChevronLeft />}
                        nextPageText={<FiChevronRight />}
                        pageRangeDisplayed={pageRangeDisplayed}
                        hideFirstLastPages={true}
                    // firstPageText="Fast"
                    // lastPageText="Last"
                    />
                </div>
            </div>
        </div>
    )
}

export default TablePagination
